import { LegacyAvailabilityProps } from './types';
import { CatSkeleton } from 'blocks-nextjs/blocks-react/components/Skeleton';
import AvailabilityTitle from '../availability-title/availability-title';
import ContactYourDealerPopover from 'components/contact-your-dealer/contact-your-dealer-popover/contact-your-dealer-popover';
import AvailabilityPickupText from '../availability-pickup-text';
import { HoseAssemblyDetails } from 'components/hose-assembly-details/hose-assembly-details';
import { shouldShowContactDealer } from '../utils';

const LegacyAvailability = ({
  availabilityData = [],
  isPickupEnabled,
  isDeliveryEnabled,
  isLoading,
  hideLabel,
  showAdditionalInfo,
  dealerData,
  locale,
  availabilityToolTipMessage,
  hoseAssemblyDetails,
  hideToolTipIcon
}: LegacyAvailabilityProps) => {
  const { hoseAssemblyIndicator, hoseAvailabilityLabel } =
    hoseAssemblyDetails || {};
  const shouldShowContactDealerOnly =
    availabilityData?.length > 0 && shouldShowContactDealer(availabilityData);
  const isQuantityAvailable =
    availabilityData?.length > 0 &&
    availabilityData?.some(({ quantityAvailable }) => quantityAvailable > 0);

  const getPopupMessage = (showContacDealerPopup: boolean, msg: string) => {
    return showContacDealerPopup || !msg ? (
      <ContactYourDealerPopover
        locale={locale}
        dealerAddress={dealerData.address}
        variant="inline"
        className="d-inline-block"
        msg={msg}
        shouldFitContent
      />
    ) : (
      <span className="ps-1">{msg}</span>
    );
  };

  const getAvailabilityContent = () =>
    (isQuantityAvailable || shouldShowContactDealerOnly) && (
      <>
        <AvailabilityTitle
          hideLabel={hideLabel}
          availabilityToolTipMessage={availabilityToolTipMessage}
          isDeliveryEnabled={isDeliveryEnabled}
          isPickupEnabled={isPickupEnabled}
          hideToolTipIcon={hideToolTipIcon}
        />
        {hoseAssemblyIndicator ? (
          <HoseAssemblyDetails hoseAvailabilityLabel={hoseAvailabilityLabel} />
        ) : (
          availabilityData.map(
            ({
              quantityAvailable,
              availabilityMessage,
              showContactDealerPopUp
            }) => {
              return (
                <p
                  className="cat-u-theme-typography-footnote"
                  key={`${quantityAvailable}-${availabilityMessage || 'contact-dealer'}`}
                >
                  {!shouldShowContactDealerOnly && (
                    <span className="fw-bolder">{quantityAvailable}</span>
                  )}
                  {getPopupMessage(showContactDealerPopUp, availabilityMessage)}
                </p>
              );
            }
          )
        )}
        {showAdditionalInfo && (
          <AvailabilityPickupText
            isDeliveryEnabled={isDeliveryEnabled}
            isPickUpEnabled={isPickupEnabled}
          />
        )}
      </>
    );

  return isLoading ? (
    <CatSkeleton data-testid="loader-id" size="lg" />
  ) : (
    getAvailabilityContent()
  );
};
export default LegacyAvailability;
